// Autogenerated file
export const routerTypesEnum = {
    OSRM: "OSRM",
    GraphHopper: "GraphHopper",
    Yatrs: "Yatrs",
    Here: "Here",
};
export const routerTypes = [
    { label: "OSRM", value: "OSRM" },
    { label: "GraphHopper", value: "GraphHopper" },
    { label: "Yatrs", value: "Yatrs" },
    { label: "Here", value: "Here" },
];
